const theme = {
  greyColor1: '#B5B4B8',
  greyTextColor: '#706F73',
  greyTextColor2: '#6A6D73',
  blackColor: '#1B1E22',
  dividerColor: '#F8F7FA',
}

export default theme